import { render, staticRenderFns } from "./PrivatePdfDownload.vue?vue&type=template&id=7fa5ce8a&"
import script from "./PrivatePdfDownload.vue?vue&type=script&lang=js&"
export * from "./PrivatePdfDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports